import AutoForm from '@components/AutoForm'
import Button from '@components/Button'
import useMessage from '@hooks/useMessage'
import useRef from '@hooks/useRef'
import Text from '@packages/justo-parts/lib/components/fields/Text'
import gql from 'graphql-tag'
import React from 'react'
import useOnEvent from 'react-app-events/lib/useOnEvent'
import {Field} from 'simple-react-form'

import Phone from '../Phone'

import styles from './styles.module.css'

export default function Profile(props) {
  const input = useRef(null)
  useOnEvent('createOrderError', error => {
    const nameRequiredMessages =
      'Tu nombre y apellido son requeridos. Ingrésalos en Información personal o en Mi cuenta > Perfil.'
    if (!error.message.includes(nameRequiredMessages)) return

    input.current.focus()
  })

  const showMessage = useMessage()
  const button = useRef()
  return (
    <div className={styles.container}>
      <AutoForm
        mutation="setUserProfile"
        buttonRef={button}
        doc={{userId: props.me._id, profile: props.me.profile}}
        onSuccess={() => showMessage('Tu perfil fue guardado')}
        fragment={gql`
          fragment checkoutUserProfile on User {
            _id
            name
            profile {
              firstName
              lastName
            }
          }
        `}
        omit={['userId']}
      >
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <Field
              ref={input}
              fieldName="profile.firstName"
              type={Text}
              label="Nombre"
              placeholder="Tu nombre"
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <Field
              fieldName="profile.lastName"
              type={Text}
              label="Apellido"
              placeholder="Tu apellido"
            />
          </div>
        </div>
      </AutoForm>
      <div>
        <Button ref={button} primary>
          Guardar
        </Button>
      </div>
      <br />
      <Phone me={props.me} close={() => {}} />
    </div>
  )
}
